import { withCDN } from 'helpers/cdn';
import {
  FALLBACK_OVERLAY_DEFAULTS,
  getOverlayTemplateManifest,
} from './overlayTemplateRegistry';

export const DEFAULT_OVERLAY_TEMPLATE_ID = FALLBACK_OVERLAY_DEFAULTS.templateId;
export const DEFAULT_RIBBON_TEXT = FALLBACK_OVERLAY_DEFAULTS.ribbonText;

export const overlayTemplateBase = (templateId: string): string =>
  withCDN(`/overlay-templates/${templateId}`);

export const resolveSponsorLogoUrl = (
  sponsorLogoKey?: string | null
): string => {
  if (!sponsorLogoKey) {
    return '';
  }
  return /^https?:\/\//.test(sponsorLogoKey)
    ? sponsorLogoKey
    : withCDN(`/${sponsorLogoKey.replace(/^\//, '')}`);
};

export const buildFollowText = (params: {
  name?: string | null;
  handle?: string | null;
  audienceLabel?: string | null;
  templateId?: string | null;
}): string => {
  const minimal =
    getOverlayTemplateManifest(params.templateId)?.followTextStyle ===
    'minimal';

  const parts: string[] = [];
  if (!minimal) {
    parts.push('FOLLOW');
    if (params.name) {
      parts.push(params.name);
    }
  }
  if (params.handle) {
    parts.push(`@${params.handle}`);
  }
  if (params.audienceLabel) {
    parts.push(`${params.audienceLabel} AUDIENCE`);
  }
  return parts.join(' · ');
};

export type StreamOverlayValues = {
  title?: string | null;
  subtitle?: string | null;
  sponsorLogoKey?: string | null;
  followText?: string | null;
  ribbonText?: string | null;
};

/** The template's text/logo inputs as the query params and message fields it reads. */
export const streamOverlayFields = (
  values: StreamOverlayValues
): Record<string, string> => ({
  title: values.title || '',
  subtitle: values.subtitle || '',
  sponsorLogoUrl: resolveSponsorLogoUrl(values.sponsorLogoKey),
  followText: values.followText || '',
  ribbonText: values.ribbonText || '',
});

/** Template URL without the text values; `hideCard` is the only mode switch. */
export const streamOverlayBaseSrc = (
  templateId: string,
  options?: { hideCard?: boolean }
): string =>
  `${overlayTemplateBase(templateId)}/index.html${
    options?.hideCard ? '?hideCard=1' : ''
  }`;

export const buildStreamOverlaySrc = (
  templateId: string,
  values: StreamOverlayValues,
  options?: { hideCard?: boolean }
): string => {
  const params = new URLSearchParams(streamOverlayFields(values));
  if (options?.hideCard) {
    params.set('hideCard', '1');
  }

  return `${overlayTemplateBase(templateId)}/index.html?${params.toString()}`;
};
